import {ViewType} from "../../core/gd/const/views/view-type";

export const EVENT_BUS_MY_TASKS_SUBMENU_CHANGED = "my-tasks-submenu:changed"

// It's for use old settings
export enum MyTasksViewName {
    ACTION_REQUIRED     = "actionRequired",
    ASSIGNED_TO_ME      = "assignedToMe",
    ALL_INVOLVED        = "allInvolved",
    CREATED_BY_ME       = "createdByMe",
    SOMEDAY             = "someday",
    PASTDUE             = "pastdue",
    HIGH_PRIORITY       = "highPriority",
}

export enum MyTasksViewPath {
    ACTION_REQUIRED = "action-required",
    ASSIGNED_TO_ME  = "assigned",
    ALL_INVOLVED    = "all-involved",
    CREATED_BY_ME   = "created",
    SOMEDAY         = "someday",
    PASTDUE         = "pastdue",
    HIGH_PRIORITY   = "high-priority"
}

// For get url by MyTasksViewName
export const myTasksViewPathDictionary = {
    [MyTasksViewName.ACTION_REQUIRED]   : MyTasksViewPath.ACTION_REQUIRED,
    [MyTasksViewName.ASSIGNED_TO_ME]    : MyTasksViewPath.ASSIGNED_TO_ME,
    [MyTasksViewName.ALL_INVOLVED]      : MyTasksViewPath.ALL_INVOLVED,
    [MyTasksViewName.CREATED_BY_ME]     : MyTasksViewPath.CREATED_BY_ME,
    [MyTasksViewName.SOMEDAY]           : MyTasksViewPath.SOMEDAY,
    [MyTasksViewName.PASTDUE]           : MyTasksViewPath.PASTDUE,
    [MyTasksViewName.HIGH_PRIORITY]     : MyTasksViewPath.HIGH_PRIORITY
}

// For get view name by MyTasksViewUrl
export const myTasksViewNameDictionary = {
    [MyTasksViewPath.ACTION_REQUIRED]    : MyTasksViewName.ACTION_REQUIRED,
    [MyTasksViewPath.ASSIGNED_TO_ME]     : MyTasksViewName.ASSIGNED_TO_ME,
    [MyTasksViewPath.ALL_INVOLVED]       : MyTasksViewName.ALL_INVOLVED,
    [MyTasksViewPath.CREATED_BY_ME]      : MyTasksViewName.CREATED_BY_ME,
    [MyTasksViewPath.SOMEDAY]            : MyTasksViewName.SOMEDAY,
    [MyTasksViewPath.PASTDUE]            : MyTasksViewName.PASTDUE,
    [MyTasksViewPath.HIGH_PRIORITY]      : MyTasksViewName.HIGH_PRIORITY
}

export type MyTasks_ViewOption = {
    url     : string
} & Option

// For get view name by ViewType (ViewType used in new MyTasksView extends View)
export const myTasksViewDictionary: {[k in ViewType]?: MyTasksViewName} = {
    [ViewType.MY_TASKS_LIST_ACTION_REQUIRED]    : MyTasksViewName.ACTION_REQUIRED,
    [ViewType.MY_TASKS_LIST_ASSIGNED_TO_ME]     : MyTasksViewName.ASSIGNED_TO_ME,
    [ViewType.MY_TASKS_LIST_ALL_INVOLVED]       : MyTasksViewName.ALL_INVOLVED,
    [ViewType.MY_TASKS_LIST_CREATED_BY_ME]      : MyTasksViewName.CREATED_BY_ME,
    [ViewType.MY_TASKS_LIST_SOMEDAY]            : MyTasksViewName.SOMEDAY,
    [ViewType.MY_TASKS_LIST_PASTDUE]            : MyTasksViewName.PASTDUE,
    [ViewType.MY_TASKS_LIST_HIGH_PRIORITY]      : MyTasksViewName.HIGH_PRIORITY,
}

export const myTasksViewOptionDictionary: {[K in MyTasksViewName]?: MyTasks_ViewOption} = {

    [MyTasksViewName.ACTION_REQUIRED]   : {
        value       : ViewType.MY_TASKS_LIST_ACTION_REQUIRED,
        label       : 'Action Required',
        icon        : 'isvg-action-required',
        url         : MyTasksViewPath.ACTION_REQUIRED,
        helpMessage : 'Tasks that require your action.',
    },

    [MyTasksViewName.ASSIGNED_TO_ME]   : {
        value       : ViewType.MY_TASKS_LIST_ASSIGNED_TO_ME,
        label       : 'Assigned To Me',
        icon        : 'isvg-assigned-to-me',
        url         : MyTasksViewPath.ASSIGNED_TO_ME,
        helpMessage : 'Tasks assigned to you.',
    },

    [MyTasksViewName.CREATED_BY_ME]   : {
        value       : ViewType.MY_TASKS_LIST_CREATED_BY_ME,
        label       : 'Created By Me',
        icon        : 'isvg-created-by-me',
        url         : MyTasksViewPath.CREATED_BY_ME,
        helpMessage : 'Tasks created by you.',
    },

    [MyTasksViewName.ALL_INVOLVED]   : {
        value       : ViewType.MY_TASKS_LIST_ALL_INVOLVED,
        label       : 'All Involved In',
        icon        : 'isvg-all-involved-in',
        url         : MyTasksViewPath.ALL_INVOLVED,
        helpMessage : 'Tasks you’re involved in as an assignee, follower, etc.',
    },

    [MyTasksViewName.SOMEDAY]   : {
        value       : ViewType.MY_TASKS_LIST_SOMEDAY,
        label       : 'Someday',
        icon        : 'isvg-someday',
        url         : MyTasksViewPath.SOMEDAY,
        helpMessage : 'Tasks postponed for later.',
    },

    [MyTasksViewName.PASTDUE]   : {
        value       : ViewType.MY_TASKS_LIST_PASTDUE,
        label       : 'Pastdue',
        icon        : 'isvg-pastdue',
        url         : MyTasksViewPath.PASTDUE,
        helpMessage : 'Tasks that are overdue and not completed.',
    },

    [MyTasksViewName.HIGH_PRIORITY]   : {
        value       : ViewType.MY_TASKS_LIST_HIGH_PRIORITY,
        label       : 'High Priority',
        icon        : 'isvg-high-priority',
        url         : MyTasksViewPath.HIGH_PRIORITY,
        helpMessage : 'Tasks with High priority.',
    },
}

// Options for view selector
export const myTasksViewOptions = ()=> {
    return Object.values(myTasksViewOptionDictionary).map((value: Option)=> {
        return value
    })
}

// Not in use now
// export const MyTasksParamName = {
//     [MyTasksViewName.ACTION_REQUIRED]   : MyTasksViewName.ACTION_REQUIRED,
//     [MyTasksViewName.ASSIGNED_TO_ME]    : MyTasksViewName.ASSIGNED_TO_ME,
//     [MyTasksViewName.CREATED_BY_ME]     : MyTasksViewName.CREATED_BY_ME,
//     [MyTasksViewName.ALL_INVOLVED]      : MyTasksViewName.ALL_INVOLVED,
//     [MyTasksViewName.SOMEDAY]           : MyTasksViewName.SOMEDAY,
//     [MyTasksViewName.PASTDUE]           : MyTasksViewName.PASTDUE,
//     [MyTasksViewName.HIGH_PRIORITY]     : MyTasksViewName.HIGH_PRIORITY
// }
